<script lang="ts" setup>

import constants from '~/constants'
import { OrderPaymentMethod, OrderPaymentMethodUtils } from '~/enums/order-payment-method'
import Page from '~/enums/page'
import type { BreadcrumbsItem } from '~/types/breadcrumbs'

const breadcrumbsItems: BreadcrumbsItem[] = [{ name: 'Главная', path: Page.Main }]
const title = 'Оплата заказов'

useHead({
  title: `${title} — iTAB`,
  meta: [{
    name: 'description',
    content: 'Полная информация о возможностях оплаты продуктов из нашего интернет-магазина.'
  }]
})
</script>

<template>
  <section>
    <div class="container">
      <Breadcrumbs :current="title" :items="breadcrumbsItems" />

      <div class="content-wrapper">
        <h1>{{ title }}</h1>

        <p class="mb-10">
          На&nbsp;сайте предусмотрена только онлайн-оплата при оформлении заказа. Онлайн-оплата заказа на&nbsp;сайте для жителей России возможна для держателей карт Visa, Mastercard и&nbsp;Мир любых банков. Для жителей других стран&nbsp;— для держателей карт Мир банков-эмитентов, поддерживающих технологию MirAccept (3-D&nbsp;Secure). Платёж осуществляется через сервис «CloudPayments»&nbsp;— это безопасная система для онлайн-операций. После оплаты на&nbsp;ваш email будет отправлен электронный чек.
        </p>

        <h2>Как оплатить банковской картой</h2>

        <p>После нажатия кнопки «Оплатить заказ» откроется виджет платёжного сервиса «CloudPayments». В&nbsp;способах оплаты выберите «Банковская карта».</p>

        <p>Введите данные банковской карты: номер, срок действия и&nbsp;код CVV/CVC (3&nbsp;цифры на&nbsp;оборотной стороне). Укажите электронную почту, на&nbsp;которую вам будет выслан чек об&nbsp;оплате.</p>

        <p>Если у&nbsp;карты включена дополнительная защита 3-D&nbsp;Secure, откроется страница для подтверждения платежа. Вам придет СМС-сообщение с&nbsp;кодом для подтверждения операции. Введите цифры в&nbsp;поле и&nbsp;завершите платёж, нажав кнопку «Отправить». На&nbsp;подтверждение оплаты с&nbsp;помощью одноразового пароля отводится ограниченное количество времени.</p>

        <p class="mb-10">
          Сразу после оплаты вы&nbsp;вернётесь на&nbsp;сайт itab.pro.
        </p>

        <template v-if="constants.isDolyameEnabled">
          <h2>Как оплатить <SvgIcon class="!w-auto" :name="OrderPaymentMethodUtils.getIconName(OrderPaymentMethod.Dolyame)" /></h2>

          <p>Сервис «Долями» помогает вам разделить сумму покупки на&nbsp;четыре равных платежа&nbsp;— без комиссии и&nbsp;дополнительных плат. Покупку получите сразу после оплаты первой части.</p>

          <p class="mb-2">
            Выберите «Долями» как способ оплаты на&nbsp;сайте, и&nbsp;сумма заказа разделится на&nbsp;4&nbsp;части:
          </p>

          <ul class="marked mb-6">
            <li>первую вы&nbsp;оплатите при оформлении заказа&nbsp;&mdash; это&nbsp;25% от&nbsp;всей суммы;</li>
            <li>оставшиеся три будут списываться с&nbsp;вашей карты автоматически, с&nbsp;интервалом в&nbsp;две недели. Перед каждым платежом вам пришлют напоминание о&nbsp;дате списания.</li>
          </ul>

          <p>Максимальная сумма заказа&nbsp;— 30&nbsp;000 руб.</p>

          <p class="mb-10">
            <a href="https://www.youtube.com/watch?v=R1bj2nXQ1Kw" target="_blank">Смотреть видео</a>.
          </p>
        </template>

        <h2>Другие способы оплаты</h2>

        <p>После нажатия кнопки «Оплатить заказ» в&nbsp;виджете платёжного сервиса «CloudPayments» вы&nbsp;можете выбрать другие способы оплаты:</p>

        <ul class="dashed mb-6">
          <li>SberPay.</li>
          <li>СБП.</li>
        </ul>

        <p>Выберите предпочтительный способ и&nbsp;следуйте инструкциям на&nbsp;экране.</p>
      </div>
    </div>
  </section>
</template>
